import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Table, TableCell, TableHead, TableBody, TableRow, Popover, colors } from '@mui/material';
import { Page, Header, Alert } from 'components';
import uuid from 'uuid/v1';

import ScfForm from './components/ScfForm.js';
import { SetFormState, GetSowList, GetSowType, GetSowTechs, GetSowRmod } from '../../actions/ScfActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	paper: {
		padding: theme.spacing(1),
	},
	popover: {
		pointerEvents: 'none',
	},
}));

const fileInfo = [
	{ type: 'Site backup', info: 'Site backup file(s)', fileformat: '.xml' },
	{ type: 'IPs', info: 'Only one file with IPs table information', fileformat: '.xlsx' },
];

const Scf = () => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(GetSowType());
	}, []);

	useEffect(() => {
		dispatch(GetSowTechs());
	}, []);

	useEffect(() => {
		dispatch(GetSowRmod());
	}, []);

	const _handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const _handlePopoverClose = () => {
		setAnchorEl(null);
	};

	return (
		<Page className={classes.root} title="Scripts">
			<Header module="Scripts" view="SCF" />
			<div className={clsx(classes.container)}>
				<Alert
					variant="info"
					message="Import file (zip) content"
					aria-owns={open ? 'mouse-over-popover' : undefined}
					aria-haspopup="true"
					onMouseOver={_handlePopoverOpen}
					onMouseLeave={_handlePopoverClose}
				/>
				<ScfForm />
				<Popover
					id="mouse-over-popover"
					className={classes.popover}
					classes={{
						paper: classes.paper,
					}}
					open={open}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={_handlePopoverClose}
					disableRestoreFocus
				>
					<Table aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>Type</TableCell>
								<TableCell>Info</TableCell>
								<TableCell>File Format</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{fileInfo.map((row) => (
								<TableRow key={uuid()}>
									<TableCell component="th" scope="row">
										{row.type}
									</TableCell>
									<TableCell>{row.info}</TableCell>
									<TableCell>{row.fileformat}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</Popover>
			</div>
		</Page>
	);
};

export default Scf;
